// click 参数是 主点击事件
// dropList 下拉按钮组的data  类似{value:1，label:'新增'}
// onDropList 下拉按钮组点击事件 根据参数判断执行事件
// 欢迎吐槽  by wjk
import template from './index.html'
import ko from 'knockout'
import Base from '../../core/base'
import './index.less'
import stringHash from 'string-hash'
const FIELDIDAFFIX = '_sub-btn'
class DropButton extends Base {
  initialize (params) {
    this.fieldid = ''
    this.text = params.text || '新增'
    let innerTpl = params.text || params.$templateNodes.length > 0 ? params.$templateNodes[0].textContent : ''
    if (params.fieldid) {
      this.fieldid = params.fieldid + FIELDIDAFFIX
    } else if (innerTpl) {
      this.fieldid = stringHash(innerTpl) + FIELDIDAFFIX
    }
    this.mainClick = params.click || function () {}
    this.isShowDrop = ko.observable(false).extend({
      rateLimit: 100
    })
    this.dropWidth = params.dropWidth
    this.type = params.type || ''
    this.dropList = params.dropList || ko.observableArray([])
    this.isMouseoverGroupBtn = params.isMouseoverGroupBtn || ko.observable(false)
  }
  methods (params) {
    this.showdropdown = () => {
      this.isShowDrop(!this.isShowDrop())
    }
    this.handleOptClick = function (item) {
      params.onDropList(item)
    }
    this.handleHideDrop = () => {
      this.isShowDrop(false)
    }
    this.overBtnShow = () => {
      this.isShowDrop(true)
    }
    this.outBtnHide = () => {
      this.isShowDrop(false)
    }
  }
}
export default {
  name: 'button-group',
  init: Base.createViewModel(DropButton),
  template
}



// WEBPACK FOOTER //
// ./src/components/dropbutton/index.js